import { inject, observer } from 'mobx-react';
import React from 'react'
import { ReactComponent as DownloadIcon } from '../../svg/download-icon.svg'
import { ReactComponent as CodeIcon } from '../../svg/code-icon.svg'
import { ReactComponent as Check } from '../../svg/check-circle.svg'
import { ReactComponent as PublishIcon } from '../../svg/publish-icon.svg'
import ModalWrapper from '../Inputs/ModalWrapper';
import CustomModalHeader from '../Inputs/CustomModalHeader';
import Loader from '../Buttons/Loader';
import ProLabel from '../Buttons/ProLabel';

@inject('workAreaStore', 'store') @observer
class PublishMenu extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      fileDropdownOpen: false,
      copied: false,
      downloadOptions: [
        {
          type: 'title',
          title: 'Optimized download'
        },
        {
          type: 'option',
          title: 'Optimized JPEG',
          size: 'col-3 offset-2 publish-menu__btn-col',
          value: 'jpeg',
          free: true,
          selected: !this.props.store.isGif,
          disabled: this.props.store.isGif
        },
        {
          type: 'option',
          size: 'col-3 publish-menu__btn-col',
          title: 'Standard PDF',
          value: 'pdf',
          selected: false,
          free: true,
          disabled: this.props.store.isGif
        },
        {
          type: 'title',
          title: 'High-resolution download',
          icon: true,
        },
        {
          type: 'option',
          title: 'Vector SVG',
          size: 'col-3 publish-menu__btn-col',
          value: 'svg',
          pro: true,
          selected: false,
          free: false,
          disabled: this.props.store.isGif
        },
        {
          type: 'option',
          title: 'High-res PNG',
          size: 'col-3 publish-menu__btn-col',
          value: 'png',
          selected: false,
          pro: true,
          free: false,
          disabled: this.props.store.isGif
        },
        {
          type: 'option',
          title: 'GIF',
          size: 'col-3 publish-menu__btn-col',
          value: 'gif',
          beta: true,
          free: false,
          selected: this.props.store.isGif,
          disabled: !this.props.store.isGif
        }
      ]
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.isGif !== prevProps.isGif){
      const v = this.props.isGif
      const copy = [...this.state.downloadOptions].map(opt => {
        if(opt.type === 'title'){
          return opt
        }
        if(opt.value === 'gif'){
          return {
            ...opt,
            selected: v,
            disabled: !v
          }
        }else{
          const obj = {
            ...opt,
            selected: false,
            disabled: v
          }
          if(opt.value === 'jpeg' && !v){
            obj.selected = true
          }
          return obj
        }
      })
      this.setState({ downloadOptions: copy })
    }
  }
  
  shareToChannel(){
    const { store, store: { auth, subscription } } = this.props
    if(auth && subscription){
      store.toggleShareModal(true)
    }else{
      //store.toggleShareModal(true)
      store.toggleUpgradeModal('publish', true)
    }
  }

  handleOptionClick(value){
    const freeDownloads = ['jpeg', 'pdf', 'gif']
    const { store, store: { auth, subscription } } = this.props
    if(subscription || freeDownloads.includes(value)){
      if(this.props.store.downloadLoading){
        return
      }
      const options = [...this.state.downloadOptions]
      options.forEach(o => {
        o.selected = false
        if(o.value === value){
          o.selected = true
        }
      })
      this.setState({
        downloadOptions: options,
        fileDropdownOpen: false
      })
      this.downloadImage()
    }
    if(!subscription && !freeDownloads.includes(value)){
      this.props.store.toggleUpgradeModal('full-res-download', true)
    }
  }

  openMoreMenu(){
    return true
  }

  getSocialMediaButtons(){
    return (
      <div className='publish-menu__social row mt-3'>
        <div className='publish-menu__col col-6'>
          <div className='publish-menu__title-wrapper'>
            <PublishIcon />
            <h5>Publish to social media</h5>
          </div>
        </div>
        <div className='publish-menu__col col-6 social-btn'>
            <button
              className='btn btn-bordered'
              onClick={() => this.shareToChannel()}
            >
            Choose platforms
            <ProLabel className={'publish-menu__pro-label-publish'} />
          </button>
        </div>
      </div>
    )
  }

  toggleDropdown(){
    this.setState({
      fileDropdownOpen: !this.state.fileDropdownOpen
    })
  }

  async downloadImage(){
    const { downloadOptions } = this.state
    const active = downloadOptions.find(({ selected }) => selected)
    this.props.store.downloadImage(active)
  }

  close(){
    const { store } = this.props
    store.toggleAnyModal('publishOpen', !this.props.store.modals.publishOpen)
  }

  getDownloadCols(isFree){
    const title = isFree ? 'Optimized' : 'High-res'
    const cols = this.state.downloadOptions.filter(({ free }) => free === isFree)
    const className = `publish-menu__col ${isFree ? 'col-4' : 'col-3'}`
    const active = this.state.downloadOptions.find(({ selected }) => selected)
    return (
      <>
        <div className={className}>
          <div className='publish-menu__sub-title-wrapper'>
            <span>{title}</span>
          </div>
        </div>
        {
          cols.map((col, idx) => {
          return (
            <div key={col.value + idx} className={'publish-menu__col ' + col.size}>
              <div className='publish-menu__btn-wrapper'>
                {
                  active && active.value === col.value && this.props.store.downloadLoading ? (
                    <div className='loader-center'>
                      <Loader className='small' />
                    </div>
                  )
                  :
                  (
                    <>
                      <button 
                        className={col.disabled ? 'btn btn-download disabled' : 'btn btn-download'}
                        disabled={col.disabled}
                        onClick={() => this.handleOptionClick(col.value)}
                      >
                        {col.value}
                      </button>
                      {
                        col.pro ? <ProLabel className={'publish-menu__pro-label-download'} /> : col.beta ? <ProLabel beta={true} className={'publish-menu__beta-label-download'} /> : undefined
                      }
                    </>
                  )
                }
              </div>
            </div>
          )
        })  
        }
      </>    
    )
  }

  getEmbedTemplate(){
    return (
      <div className='col-12 design-menu__embed-col'>
        <input
          className='form-control'
          value={this.props.store.embedDesign || 'Empty design...'}
          disabled
        />
      </div>
    )
  }

  copyCode(e){
    e.preventDefault()
    const node = document.createElement('textarea')
    node.classList.add('temp-copy-input')
    node.style = 'z-index: -1; position: absolute; left: 0; top: 0;'
    node.textContent = this.props.store.embedDesign
    document.body.appendChild(node)
    const area = document.querySelector('.temp-copy-input')
    area.focus()
    area.select()
    document.execCommand('copy')
    area.remove()
    this.setState({ copied: true })
    setTimeout(() => {
      this.setState({ copied: false })
    }, 5000)
  }


  render(){
    if(!this.props.store.modals.publishOpen){
      return <div />
    }
    const { downloadLoading, gifStatus, gifProgression, largeGifWarning } = this.props.store
    return (
      <ModalWrapper
        close={this.close.bind(this)}
        modalClass={'download'}
      >
        <CustomModalHeader
          close={this.close.bind(this)}
          title={'Download'}
          headerClass={'download-menu__h'}
        />
          <div className='publish-menu custom-dropdown-menu'>
            {/* {
              this.getSocialMediaButtons()
            } */}
            <div className='publish-menu__download mt-3 row'>
              <div className='publish-menu__col col-12'>
                <div className='publish-menu__title-wrapper'>
                  <DownloadIcon />
                  <h5>Download</h5>
                </div>
              </div>
              {this.getDownloadCols(true)}
              {this.getDownloadCols(false)}
              <div className='publish-menu__col col-10 offset-1'>
                {
                  downloadLoading && gifStatus ? (
                    <>
                    <div className='download__progress'>
                      <div 
                        className='download__progress-bar progress-bar' 
                        aria-valuenow={gifProgression} 
                        aria-valuemin="0" 
                        aria-valuemax="100" 
                        style={{
                          width: `${gifProgression}%`
                        }}
                      />
                    </div>
                    <span className='gray download__progression-text'>
                      {
                        gifStatus
                      }
                    </span>
                    { largeGifWarning ? (
                      <span className='warning download__large-gif-warning'>
                        {largeGifWarning}
                      </span>
                    )
                    :
                    undefined}
                    </>
                  )
                  :
                  undefined
                }
              </div>
            </div>
            <div className='publish-menu__html mt-3 row'>              
              <div className='publish-menu__col col-12'>
                <div className='publish-menu__title-wrapper'>
                  <CodeIcon style={{marginTop: '10px'}} />
                  <h5 style={{marginTop: '10px'}}>
                    Embed Design
                  </h5>
                  {
                    this.state.copied ? (
                      <Check className='ml-auto copy-check' />
                    )
                    :
                    (
                    <button
                      className='btn btn-bordered ml-auto'
                      onClick={e => this.copyCode(e)}
                    >
                      Copy code
                    </button>
                    )
                  }
                </div>
              </div>
              {
                this.getEmbedTemplate()
              }
            </div>
          </div>
      </ModalWrapper>
    )
  }

}

/*
<div className='col-8'>
                <h6>Download</h6>
                {
                  <Dropdown
                    options={downloadOptions}
                    caret={true}
                    title='File type:'
                    className={'file-dropdown'}
                    isOpen={fileDropdownOpen}
                    onClick={this.handleOptionClick.bind(this)}
                    toggle={this.toggleDropdown.bind(this)}
                  />
                }
              </div>
              <div className='col-4'>
                {downloadLoading ? 
                  (
                    <span>Loading</span>
                  )
                  :
                  (
                  <button 
                    className='btn btn-primary'
                    onClick={() => this.downloadImage()}
                  >
                    Download
                  </button>
                  )
                }
              </div>
*/

export default PublishMenu